import React, { Component } from 'react';
import List, { ListItem, ListItemText } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import { config } from '../config';
import { db } from '../ThirdPartyIntegration/firebaseClient'
import { browserHistory } from 'react-router'

class Matches extends Component {
    constructor() {
        super();

        let userJsonString = window.localStorage.getItem(config.localstorage.userKey);
        let user = JSON.parse(userJsonString);

        this.state = {
            matches: []
        }

        db.ref(`users/${user.uid}/matches`).on('value', (matchesSnap) => {
            matchesSnap.forEach((match) => {
                db.ref(`users/${match.key}/info`).once('value')
                    .then((userInfoSnap) => {
                        let userInfo = userInfoSnap.val();
                        let newelement = {
                            uid: userInfo.uid,
                            picture: userInfo.picture,
                            conversationId: match.val().conversationId
                        }
                        this.setState({
                            matches: this.state.matches.concat([newelement])
                        })
                    })
            })
        });

        this.onClickGoToConversation = this.onClickGoToConversation.bind(this);
    }

    onClickGoToConversation(conversationId) {
        browserHistory.push('/loggedin/conversation/' + conversationId);
    }

    render() {
        if (this.state.matches.length > 0) {
            return (
                <div>
                    <List>
                        {this.state.matches.map(value =>
                            <ListItem dense button key={value.uid} onClick={() => {this.onClickGoToConversation(value.conversationId)}}>
                                <Avatar alt={value.uid} src={value.picture} />
                                <ListItemText primary={value.uid} />
                            </ListItem>
                        )}
                    </List>
                </div>
            )
        } else {
            return (
                <div>
                    Boo... No matches yet.
                </div>
            )
        }
    }
}

export default Matches;


// WEBPACK FOOTER //
// ./src/Components/Matches.jsx